export enum YesNoDialogPrimaryButton {
    PrimaryButtonYes,
    PrimaryButtonNo
}

export enum YesNoDialogResult {
    Yes,
    No
}
